module.exports = __webpack_public_path__ + "media/images/short_scenario_contest/theme-pic02@3x-00618486843ff4a4a0cc9b1fd51fa3e9.png";